function Ctrl($scope, $stateParams, authService) {
  $scope.reset = function() {
    $scope.infoMessage = null;
    $scope.successMessage = null;
    $scope.errorMessage = null;
    $scope.isReset = false;

    if ($scope.password1 !== $scope.password2) {
      $scope.errorMessage = 'Passwords must match';
    } else {
      $scope.infoMessage = 'Updating password...';
      $scope.buttonDisable = true;

      authService.resetPassword($stateParams.resetToken, $scope.password1,
        function() {
          $scope.infoMessage = null;
          $scope.buttonDisable = false;
          $scope.successMessage = 'Password updated successfully';
          $scope.isReset = true;
        },
        function(data, status) {
          $scope.infoMessage = null;
          $scope.buttonDisable = false;
          if (status === 404) {
            $scope.errorMessage = 'Your password reset token is not valid';
          } else {
            $scope.errorMessage = 'There was an error reseting your password';
          }
        }
      );
    }
  };
}

Ctrl.$inject = [
  '$scope',
  '$stateParams',
  'tl.auth.service'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/resetPassword/resetPasswordCtrl.js